import { createAsyncThunk } from '@reduxjs/toolkit';
import { registerService } from 'services';
import { ThunkAPI, RegisterError, RegisterResponse, newItem } from 'types';

export const newOrder = createAsyncThunk<RegisterResponse, newItem, ThunkAPI<RegisterError>>(
  'RegisterPage/register',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await registerService.newOrder(params);
      await registerService.candidateBilling(data.item_id);
      return data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error);
    }
  },
);
